import Config from 'react-native-config';
import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { createHttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
import ApolloClient, { DefaultOptions } from 'apollo-client';
import { InMemoryCache, NormalizedCacheObject } from 'apollo-cache-inmemory';
import Logger from 'services/Logger';
import { buildAxiosFetch } from '@lifeomic/axios-fetch';
import axios from 'axios';
import { resolvers } from '../services/client/resolvers';

interface ApolloClientArgs {
  getHeaders(context: Record<string, any>): Promise<{ [key: string]: string }>;
}

// @ts-expect-error
const apolloFetchClient: any = buildAxiosFetch(axios.create());

const payingForCareHttpLink = createHttpLink({
  uri: Config.GRAPHQL_ENDPOINT_URL as string,
  fetch: apolloFetchClient
});

const orchestrationHttpLink = createHttpLink({
  uri: Config.ORCHESTRATION_BASE_URL as string,
  fetch: apolloFetchClient
});

const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors) {
    Logger.error('GraphQL Error', graphQLErrors);
  }
});

export function createApolloClient(args?: ApolloClientArgs): ApolloClient<NormalizedCacheObject> {
  const authLink = setContext(async (_, context = {}) => {
    const extraHeaders = args ? await args.getHeaders(context) : {};

    const { headers } = context;
    if (Config.LOCAL_GRAPHQL_X_API_KEY) {
      extraHeaders['x-api-key'] = Config.LOCAL_GRAPHQL_X_API_KEY;
    }

    return {
      headers: {
        ...headers,
        ...extraHeaders
      }
    };
  });

  const link = ApolloLink.from([
    errorLink,
    authLink.split(
      operation => operation.getContext().clientName === 'orchestration',
      orchestrationHttpLink,
      payingForCareHttpLink
    )
  ]);

  const defaultOptions: DefaultOptions = {
    watchQuery: {
      fetchPolicy: 'no-cache'
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore'
    }
  };

  const cache = new InMemoryCache();

  return new ApolloClient({
    cache,
    link,
    resolvers,
    defaultOptions
  });
}
